import { SocketContext } from "../../Providers/SocketProvider";
import { useContext } from "react";

export const useSocket = () => {
  const socketContext = useContext(SocketContext);

  if (
    socketContext &&
    typeof socketContext === "object" &&
    "socket" in socketContext
  ) {
    return socketContext.socket;
  }

  return socketContext;
};

export const useSocketReconnect = () => {
  const socketContext = useContext(SocketContext);

  if (
    socketContext &&
    typeof socketContext === "object" &&
    "reconnect" in socketContext &&
    typeof socketContext.reconnect === "function"
  ) {
    return socketContext.reconnect;
  }

  return () => {};
};